export default [
	{
		id: "Kristin Mccoy",
		name: "Kristin Mccoy",
		post: "Medical director",
		phone: "(405) 555-0128",
		mail: "kmccoy@gmail.com",
		photo: "./assets/images/staff/big-avatar-1.jpg",
	},
	{
		id: "Theo Fisher",
		name: "Theo Fisher",
		post: "Head of department",
		phone: "(405) 632-1372",
		mail: "tfisher@gmail.com",
		photo: "./assets/images/staff/big-avatar-2.jpg",
		parent: "Kristin Mccoy",
	},
	{
		id: "Francesca Saunders",
		name: "Francesca Saunders",
		post: "Attending physician",
		phone: "(402) 371-6736",
		mail: "fsaunders@gmail.com",
		photo: "./assets/images/staff/big-avatar-3.jpg",
		parent: "Theo Fisher",
		open: false,
	},
	{
		id: "Jenson Brown",
		name: "Jenson Brown",
		post: "Fellow",
		phone: "(346) 622-8633",
		mail: "jbrown@gmail.com",
		photo: "./assets/images/staff/big-avatar-14.jpg",
		parent: "Francesca Saunders",
		dir: "vertical",
	},
	{
		id: "Raya Marshall",
		name: "Raya Marshall",
		post: "Resident",
		phone: "(846) 962-1723",
		mail: "rmarshall@gmail.com",
		photo: "./assets/images/staff/big-avatar-16.jpg",
		parent: "Jenson Brown",
	},
	{
		id: "Tom Walsh",
		name: "Tom Walsh",
		post: "Resident",
		phone: "(763) 213-8373",
		mail: "twalsh@gmail.com",
		photo: "./assets/images/staff/big-avatar-17.jpg",
		parent: "Jenson Brown",
	},
	{
		id: "Harvey Pearce",
		name: "Harvey Pearce",
		post: "Resident",
		phone: "(364) 234-7523",
		mail: "hpearce@gmail.com",
		photo: "./assets/images/staff/big-avatar-18.jpg",
		parent: "Jenson Brown",
	},
	{
		id: "Archie Barnes",
		name: "Archie Barnes",
		post: "Fellow",
		phone: "(578) 342-1237",
		mail: "abarnes@gmail.com",
		photo: "./assets/images/staff/big-avatar-19.jpg",
		parent: "Francesca Saunders",
		dir: "vertical",
	},
	{
		id: "Emelia Green",
		name: "Emelia Green",
		post: "Resident",
		phone: "(832) 426-2223",
		mail: "egreen@gmail.com",
		photo: "./assets/images/staff/big-avatar-20.jpg",
		parent: "Archie Barnes",
	},
	{
		id: "Dylan Barrett",
		name: "Dylan Barrett",
		post: "Resident",
		phone: "(523) 125-2523",
		mail: "dbarrett@gmail.com",
		photo: "./assets/images/staff/big-avatar-21.jpg",
		parent: "Archie Barnes",
	},
	{
		id: "Abraham Johnston",
		name: "Abraham Johnston",
		post: "Fellow",
		phone: "(251) 315-4731",
		mail: "ajohnston@gmail.com",
		photo: "./assets/images/staff/big-avatar-22.jpg",
		parent: "Francesca Saunders",
		dir: "vertical",
	},
	{
		id: "Philippa Holmes",
		name: "Philippa Holmes",
		post: "Resident",
		phone: "(151) 231-1256",
		mail: "pholmes@gmail.com",
		photo: "./assets/images/staff/big-avatar-23.jpg",
		parent: "Abraham Johnston",
	},
	{
		id: "Claudia Fraser",
		name: "Claudia Fraser",
		post: "Resident",
		phone: "(125) 215-2636",
		mail: "cfraser@gmail.com",
		photo: "./assets/images/staff/big-avatar-24.jpg",
		parent: "Abraham Johnston",
	},
	{
		id: "Alisha Hall",
		name: "Alisha Hall",
		post: "Head of department",
		phone: "(405) 372-9756",
		mail: "ahall@gmail.com",
		photo: "./assets/images/staff/big-avatar-4.jpg",
		parent: "Kristin Mccoy",
		open: false,
	},
	{
		id: "Milena Hunter",
		name: "Milena Hunter",
		post: "Attending physician",
		phone: "(124) 622-1256",
		mail: "mhunter@gmail.com",
		photo: "./assets/images/staff/big-avatar-25.jpg",
		parent: "Alisha Hall",
		dir: "vertical",
	},
	{
		id: "Bradley Sutton",
		name: "Bradley Sutton",
		post: "Fellow",
		phone: "(325) 154-6232",
		mail: "bsutton@gmail.com",
		photo: "./assets/images/staff/big-avatar-26.jpg",
		parent: "Milena Hunter",
	},
	{
		id: "Joel Stevens",
		name: "Joel Stevens",
		post: "Fellow",
		phone: "(165) 463-1232",
		mail: "jstevens@gmail.com",
		photo: "./assets/images/staff/big-avatar-27.jpg",
		parent: "Milena Hunter",
	},
	{
		id: "Axel Khan",
		name: "Axel Khan",
		post: "Fellow",
		phone: "(578) 734-3633",
		mail: "akhan@gmail.com",
		photo: "./assets/images/staff/big-avatar-28.jpg",
		parent: "Milena Hunter",
	},
	{
		id: "Maximus Dixon",
		name: "Maximus Dixon",
		post: "Medical director",
		phone: "(264) 684-4373",
		mail: "mdixon@gmail.com",
		photo: "./assets/images/staff/big-avatar-29.jpg",
		parent: "Alisha Hall",
		dir: "vertical",
	},
	{
		id: "Sami Morris",
		name: "Sami Morris",
		post: "Fellow",
		phone: "(437) 347-3473",
		mail: "smorris@gmail.com",
		photo: "./assets/images/staff/big-avatar-30.jpg",
		parent: "Maximus Dixon",
	},
	{
		id: "Jessica Murray",
		name: "Jessica Murray",
		post: "Fellow",
		phone: "(436) 348-8692",
		mail: "jmurray@gmail.com",
		photo: "./assets/images/staff/big-avatar-31.jpg",
		parent: "Maximus Dixon",
	},
	{
		id: "Maryam Barker",
		name: "Maryam Barker",
		post: "Fellow",
		phone: "(632) 324-3262",
		mail: "mbarker@gmail.com",
		photo: "./assets/images/staff/big-avatar-32.jpg",
		parent: "Maximus Dixon",
	},
	{
		id: "Edward Sharp",
		name: "Edward Sharp",
		post: "Head of department",
		phone: "(451) 251-2578",
		mail: "esharp@gmail.com",
		photo: "./assets/images/staff/big-avatar-6.jpg",
		parent: "Kristin Mccoy",
		dir: "vertical",
	},
	{
		id: "Cruz Burke",
		name: "Cruz Burke",
		post: "Attending physician",
		phone: "(587) 234-8975",
		mail: "cburke@gmail.com",
		photo: "./assets/images/staff/big-avatar-7.jpg",
		parent: "Edward Sharp",
	},
	{
		id: "Eloise Saunders",
		name: "Eloise Saunders",
		post: "Attending physician",
		phone: "(875) 231-5332",
		mail: "esaunders@gmail.com",
		photo: "./assets/images/staff/big-avatar-8.jpg",
		parent: "Edward Sharp",
	},
	{
		id: "Sophia Matthews",
		name: "Sophia Matthews",
		post: "Attending physician",
		phone: "(361) 423-7234",
		mail: "smatthews@gmail.com",
		photo: "./assets/images/staff/big-avatar-9.jpg",
		parent: "Edward Sharp",
	},
	{
		id: "Kara Foster",
		name: "Kara Foster",
		post: "Attending physician",
		phone: "(565) 525-0672",
		mail: "kfoster@gmail.com",
		photo: "./assets/images/staff/big-avatar-10.jpg",
		parent: "Edward Sharp",
	},
	{
		id: "Peter Cox",
		name: "Peter Cox",
		post: "Head of department",
		phone: "(732) 321-2312",
		mail: "pcox@gmail.com",
		photo: "./assets/images/staff/big-avatar-11.jpg",
		parent: "Kristin Mccoy",
		dir: "vertical",
	},
	{
		id: "Nancy Collins",
		name: "Nancy Collins",
		post: "Attending physician",
		phone: "(743) 235-1263",
		mail: "ncollins@gmail.com",
		photo: "./assets/images/staff/big-avatar-12.jpg",
		parent: "Peter Cox",
		open: false,
	},
	{
		id: "Alyssa Day",
		name: "Alyssa Day",
		post: "Fellow",
		phone: "(623) 265-2362",
		mail: "aday@gmail.com",
		photo: "./assets/images/staff/big-avatar-33.jpg",
		parent: "Nancy Collins",
	},
	{
		id: "Nancy Newman",
		name: "Nancy Newman",
		post: "Fellow",
		phone: "(347) 236-2373",
		mail: "nnewman@gmail.com",
		photo: "./assets/images/staff/big-avatar-34.jpg",
		parent: "Nancy Collins",
	},
	{
		id: "Honey Black",
		name: "Honey Black",
		post: "Attending physician",
		phone: "(263) 234-8756",
		mail: "hblack@gmail.com",
		photo: "./assets/images/staff/big-avatar-13.jpg",
		parent: "Peter Cox",
	},
	{
		id: "Archie Moore",
		name: "Archie Moore",
		post: "Attending physician",
		phone: "(705) 236-5742",
		mail: "amoore@gmail.com",
		photo: "./assets/images/staff/big-avatar-5.jpg",
		parent: "Peter Cox",
	},
];
